import { FC, useState, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { getRelatives, resetLoading } from "app/features/reportsSlice";
import withAuth from "lib/hoc/withAuth";
import TableLayout from "components/Forms/TableLayout/TableLayout";
import Filters from "./components/Filters";
import Table from "./components/Table";
import { relativeColumns, relativeFileColumns } from "./components/columns";
import { DatasheetReport } from "types";
import { relativesGridMapper } from "lib/helpers/reportsHelper";
import { exportToXLSX } from "lib/helpers/convertToXLS";

const Relatives: FC = () => {
  const dispatch = useAppDispatch();
  const { relatives, loading } = useAppSelector((state) => state.reports);
  const [loadingFile, setLoadingFile] = useState(false);

  const handleSelect = (payload: DatasheetReport) => {
    dispatch(getRelatives(payload));
  };

  useEffect(() => {
    dispatch(resetLoading());
  }, []);

  function handleExportFile() {
    setLoadingFile(true);
    setTimeout(() => {
      const data = relativesGridMapper(relatives);
      const filename = "Parientes.xlsx";
      exportToXLSX(data, relativeFileColumns, filename);
      setLoadingFile(false);
    }, 1000);
  }

  return (
    <TableLayout maxWidthCard={1600} maxWidthContainer='xl' title='Parientes'>
      <Filters
        isLoading={loading}
        loadingFile={loadingFile}
        handleSelect={handleSelect}
        handleExportFile={handleExportFile}
        isButtonEnabled={!relatives?.length}
      />
      <Table
        isLoading={loading}
        dataGridColumns={relativeColumns}
        rows={relativesGridMapper(relatives)}
        fileName='Parientes'
      />
    </TableLayout>
  );
};

export default withAuth(Relatives);
